var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_41",
    "data-name": "Grupo 41",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.876,
    height: 86.046,
    viewBox: "0 0 84.876 86.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M256.342,628.555a13.018,13.018,0,1,1,13.019-13.024A13.02,13.02,0,0,1,256.342,628.555Z",
    transform: "translate(-213.906 -602.52)",
    fill: "#00dba1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M202.4,627.385a9.112,9.112,0,1,1,9.112-9.114A9.113,9.113,0,0,1,202.4,627.385Z",
    transform: "translate(-193.289 -605.256)",
    fill: "#00dba1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M315.76,627.385a9.112,9.112,0,1,1,9.113-9.114A9.113,9.113,0,0,1,315.76,627.385Z",
    transform: "translate(-239.997 -605.256)",
    fill: "#00dba1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M259.075,684.064a9.112,9.112,0,1,1,9.112-9.116A9.114,9.114,0,0,1,259.075,684.064Z",
    transform: "translate(-216.641 -628.61)",
    fill: "#00dba1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M260.991,739.926a6.378,6.378,0,1,1,6.377-6.382A6.38,6.38,0,0,1,260.991,739.926Z",
    transform: "translate(-218.557 -653.881)",
    fill: "#00dba1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo-green.cd7925fe394c933db7bfa8e3965d585f.svg";
export { ForwardRef as ReactComponent };